module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment-widget-v2"
  }, [_c('comment-form', {
    attrs: {
      "contentUuid": _vm.$data.contentUuid,
      "contentType": _vm.$data.contentType,
      "client": _vm.$data.client,
      "authorUuid": _vm.$data.authorUuid,
      "siteUuid": _vm.$data.siteUuid
    },
    on: {
      "new-comment": _vm.addComment
    }
  }), _vm._v(" "), _c('div', [_vm._l((_vm.comments), function(comment) {
    return _c('div', {
      key: comment.uuid
    }, [_c('comment', {
      attrs: {
        "client": _vm.$data.client,
        "comment": comment,
        "contentUuid": _vm.$data.contentUuid,
        "contentType": _vm.$data.contentType,
        "siteUuid": _vm.$data.siteUuid,
        "authorUuid": _vm.$data.authorUuid,
        "child": "false"
      }
    })], 1)
  }), _vm._v(" "), (_vm.hasNextPage) ? _c('div', {
    staticClass: "load-more",
    on: {
      "click": _vm.fetchMore
    }
  }, [_vm._v("Load more comments")]) : _vm._e()], 2), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "eq-loading"
  }, [_vm._v("Loading …")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e1d7d1b!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/organisms/comment-widget/comment-widget.vue
// module id = 701
// module chunks = 4